module.exports = __webpack_public_path__ + "static/media/darwinPortraits.7842f69a.jpg";